'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactFela = require('react-fela');

var Text = function Text(props) {
  return {
    fontFamily: props.family,
    fontSize: props.size,
    lineHeight: props.height,
    fontWeight: props.weight || props.bold && 700 || 400,
    fontStyle: props.italic && 'italic',
    color: props.color,

    extend: [{
      condition: props.antialiased,
      style: {
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale'
      }
    }, {
      condition: props.ellipsis,
      style: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
      }
    }]
  };
};

exports.default = (0, _reactFela.createComponent)(Text);
module.exports = exports['default'];